import React from "react";

import Switch from "@mui/material/Switch";
import Checkbox from "@mui/material/Checkbox";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";

import { TFieldAccess } from "../../parametersProcessor/paramAccess";

/**
 * BE/KI KAPCSOLÓ — a `FormControlLabel` + kapcsoló blokk, ami eddig három-négy kártyán ismétlődött
 * (Composite, Distribution, BackPassing, Railing), soronként szinte azonosan.
 *
 * KÉT DOLGOT SZÁNDÉKOSAN NEM EGYSÉGESÍT, hogy a meglévő kártyák megjelenése ne változzon:
 *
 *   - `control`: a Railing ma `Checkbox`-ot használ, a többi `Switch`-et. Funkcionális oka nincs, de a
 *     váltás LÁTHATÓ változás lenne, ezért a híváshely dönt, és mindenki a mait kapja.
 *   - `tooltip`: a Composite és a Distribution `Tooltip`-be csomagolja a mezőt (üres címmel is), a
 *     BackPassing nem csomagol. Ezért a burkolás akkor és csak akkor történik meg, ha a hívó megadta a
 *     propot — `undefined` esetén a DOM pontosan olyan marad, mint ma.
 */
interface IToggleFieldProps {
    label?: string;
    /** Ha meg van adva (akár üresen), a mező `Tooltip`-be kerül. Hiányában nincs burkolás. */
    tooltip?: string;
    checked: boolean;
    access: TFieldAccess;
    control?: "switch" | "checkbox";
    onChange: (checked: boolean) => void;
}

const ToggleField: React.FC<IToggleFieldProps> = ({
    label,
    tooltip,
    checked,
    access,
    control = "switch",
    onChange,
}) => {
    const disabled = !access.editable || access.readOnly;
    const input = control === "checkbox"
        ? <Checkbox checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} />
        : <Switch checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} />;

    const field = <FormControlLabel control={input} label={label ?? ""} />;

    return tooltip === undefined ? field : <Tooltip title={tooltip} arrow>{field}</Tooltip>;
};

export default ToggleField;
